import { html, repeat, ref, ExecutionContext, when } from '@microsoft/fast-element';
import { AssignedUsers } from './assigned-users';
import { COLUMNS_CONFIG } from './column-config';
import { assignUser, unassignUser } from '../../../../../styles';
import { sync } from '@genesislcap/foundation-utils';

const targetValue = (ctx: ExecutionContext) => (ctx.event.target! as any).value;

export const assignedUsersTemplate = html<AssignedUsers>`
  <div class="wrapper">
    <div class="header-container">
      <div class="header">
        ${(x) => (x.showAssignedUsers ? 'Assigned Users' : 'Assign New Users')}
      </div>
      ${when(
        (x) => x.showAssignedUsers,
        html`
          <div class="button-container">
            <zero-button
              appearance="stealth"
              @click=${(x) => x.downloadSelected()}
              ?disabled="${(x) => !x.isUserSelected}"
            >
              <zero-icon variant="solid" size="lg" name="download"></zero-icon>
            </zero-button>
            <zero-button
              appearance="danger"
              @click=${(x) => x.unassignSelectedUsers()}
              ?disabled="${(x) => !x.isUserSelected || x.company?.IS_SPV_FLAG}"
            >
              ${unassignUser('start')} Un-assign Selected Users
            </zero-button>
            <zero-button
              appearance="primary"
              @click=${(x) => x.assignMoreUsers()}
              ?disabled="${(x) => x.company?.IS_SPV_FLAG}"
            >
              ${assignUser('start')} Assign More Users
            </zero-button>
          </div>
        `,
      )}
      ${when(
        (x) => !x.showAssignedUsers,
        html`
          <div class="button-container">
            <zero-text-field
              :value="${sync((x) => x.searchUsersValue)}"
              placeholder="Search Users..."
              class="full-width"
              @input="${(x, c) => x.setUserData(targetValue(c))};"
            ></zero-text-field>
          </div>
        `,
      )}
    </div>

    <zero-grid-pro
      class="grid-styles"
      only-template-col-defs
      sideBar=""
      rowSelection="multiple"
      ${ref('assignedUsersGrid')}
    >
      ${repeat(
        (x) => COLUMNS_CONFIG(x),
        html`
          <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
        `,
      )}
    </zero-grid-pro>

    <zero-button
      appearance="primary"
      @click=${(x) => x.assignSelectedUsers()}
      style="position: absolute; bottom: 22px; right: 35px; display: ${(x) =>
        x.showAssignedUsers ? 'none' : ''}"
      ?disabled="${(x) => x.company?.IS_SPV_FLAG}"
    >
      Assign Selected Users
    </zero-button>
  </div>
`;
